/**
 * enroll 标签数据接口文档
 */
import {
  Method,
  Mode
} from '../core';
import {
  API,
  LOCAL,
  SOURCE
} from '../config';

const api = API;
// const api = 'http://115.238.39.106:28085/service';

export default {
  // 企业人工实名上传图片
  uploadImg: {
    url: `${api}/rest/v1/file/upload2oss`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      file: {}
    }
  },
  // 企业 人工 信息
  manual: {
    url: `${api}/rest/v1/realname/organ/manual`,
    method: Method.POST,
    body: {
      step: {
        $type: Number
      }, // 区分 企业信息，图片，银行信息
      organType: {
        $type: Number
      }, // 单位类型
      licenseType: {
        $type: Number
      }, // 营业执照类型
      name: {
        $type: String
      }, // 企业名称
      regCode: {
        $type: String
      }, // 工商注册号
      organCode: {
        $type: String
      }, // 组织结构代码
      legalArea: {
        $type: Number
      }, // 法人代表归属地
      legalName: {
        $type: String
      }, // 法人姓名
      legalIdNo: {
        $type: String
      }, // 法人身份证号码
      userType: {
        $type: Number
      }, // 注册类型
      legalPhoto: {
        $type: String
      },
      agentName: {
        $type: String
      }, // 代理人名称
      agentIdNo: {
        $type: String
      }, // 代理人身份证
      regPhoto: {
        $type: String
      }, // 工商注册号
      organPhoto: {
        $type: String
      }, // 组织机构代码
      legalPhotoPro: {
        $type: String
      }, // 法人身份证正面
      legalPhotoCon: {
        $type: String
      }, // 法人身份证反面
      agentPhotoPro: {
        $type: String
      }, // 代理人身份证正面
      agentPhotoCon: {
        $type: String
      }, // 代理人身份证反面
      agentPhoto: {
        $type: String
      }, // 代理人手持身份证照片
      proxyPhoto: {
        $type: String
      }, // 授权书照片
      bankAccount: {
        $type: String
      }, // 对公账户名
      bankNum: {
        $type: String
      }, // 企业对公银行账户
      bank: {
        $type: String
      }, // 企业银行账户开户行
      subbranch: {
        $type: String
      }, // 企业银行账户开户行名称
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 企业人工实名上传图片
  person: {
    url: `${api}/rest/v1/realname/person/manual`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      personArea: {
        $type: Number
      }, // 个人归属地
      name: {
        $type: String
      }, // 姓名
      idNo: {
        $type: String
      }, // 身份证号
      idPhotoPro: {
        $type: String
      }, // 身份证正面URL
      idPhotoCon: {
        $type: String
      }, // 身份证背面URL
      photo: {
        $type: String
      }, // 个人近照URL
      bank: {
        $type: String
      }, // 企业银行账号开户行名称
      subbranch: {
        $type: String
      }, // 企业支行
      bankNum: {
        $type: String
      } // 企业对公银行账号
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/enroll.js